export interface PortalVariant {
  id: string;
  platform: string;
  platformLabel: string;
  channelName: string;
  body: string;
  title: string | null;
  hashtags: string[];
  firstComment: string | null;
}

export interface PortalFeedback {
  id: string;
  authorLabel: string;
  body: string;
  resolvedAt: number | null;
  createdAt: number;
}

export interface PortalPost {
  id: string;
  scheduledAt: number;
  dayKey: string;
  status: string;
  revision: number;
  variants: PortalVariant[];
  feedback: PortalFeedback[];
}

export interface PortalApproval {
  scope: string;
  scopeKey: string | null;
  decision: string;
  actorLabel: string;
  note: string | null;
  createdAt: number;
}

export interface PortalPlan {
  plan: {
    id: string;
    title: string;
    status: string;
    periodStart: number;
    periodEnd: number;
  };
  workspace: { name: string; timezone: string };
  posts: PortalPost[];
  approvals: PortalApproval[];
  me: { email: string; name: string | null; role: string };
}

export interface PortalIntro {
  workspaceName: string;
  planTitle: string;
  signedIn: boolean;
  email: string | null;
}

/** Plain-language status, since the client never sees our internal wording. */
export function statusLabel(status: string): string {
  switch (status) {
    case "approved":
    case "scheduled":
      return "Approved";
    case "published":
      return "Published";
    case "declined":
      return "Declined";
    case "changes_requested":
      return "Changes asked for";
    case "pending_review":
    case "draft":
      return "Waiting for you";
    default:
      return status.replace(/_/g, " ");
  }
}

export function statusKind(status: string): "ok" | "warn" | "error" | "" {
  if (["approved", "scheduled", "published"].includes(status)) return "ok";
  if (["declined"].includes(status)) return "error";
  if (["changes_requested"].includes(status)) return "warn";
  return "";
}
